
import { defineComponent } from 'vue';
import { overlayComposition } from '@/core/modules/overlay/services';

export default defineComponent({
    props: {
        section: {
            type: String,
            required: true
        }
    },
    setup () {
        const overlays = [
            'safety-outcomes',
            'interim-final-analysis'
        ];

        return { ...overlayComposition(), overlays }
    }
})
